import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import referenceDataReducer from "./slices/referenceDataSlice";
import themeReducer from "./slices/themeSlice";
import ticketsReducer from "./slices/ticketsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    tickets: ticketsReducer,
    referenceData: referenceDataReducer,
  },
});

export default store;
